export default {
    namespaced: true,
    state: {
        topNavbar: undefined
    },
    actions: {},
    mutations: {
        setTopNavbar(state, value) {
            state.topNavbar = value
        }
    },
    getters: {}
}